var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1668C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0056B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004C9E"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#sg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 33) scale(0.64) translate(-32 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 54.7V9.3",
    stroke: "#FFFFFF",
    strokeWidth: 4.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 10.7l24 9.6-24 9.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.3,
    cy: 55,
    rx: 17.3,
    ry: 3.7,
    fill: "none",
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 3.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeStart);
export default __webpack_public_path__ + "static/media/badge-start.593d1b2aa58606ca7f908ea5728c67ad.svg";
export { ForwardRef as ReactComponent };